/* PDP contents card (snippets/kkumi-pdp-contents.liquid; PDP hero v3
   handoff, phase 5).

   The card lists what one bundle, kit or pack contains (product metafield
   kkumi.contents). A line with an `option` (data-kk-follow) follows that
   option in the buy box, matched on its name or displayed label:
   - value = the chosen card's title, price = its "+$X" line, the chosen
     card's photo over the line's own, "pre-selected" until the shopper picks
     in it (not after a ?variant= link), Change (or Choose while it is blank);
   - a "no" choice (No tweezers, data-kk-none from Liquid) swaps the line for
     its "Add …" row, which shows the cheapest extra cost;
   - no such option on the page: a fixed "Included" line.
   Change / Choose / Add open the option (option rows open the row via
   kk:open-option), scroll it under the sticky header (or to the top of the
   quick-view modal) and focus its checked card. Nothing is ever picked or
   added from here.

   Totals ("Altogether") add up `quantity` per `unit` across the lines shown,
   kit contents included (times the kit line's quantity). "[value]" in a
   unit becomes that line's chosen value, so "[value] outer" totals per
   colour. Always one bundle: the quantity stepper only changes the label.

   Copy rides data-* on the card (section settings). */
(function () {
  function toArray(list) { return Array.prototype.slice.call(list); }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function textOf(n) { return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; }
  // Idempotent writes (MutationObserver feedback-loop rule, FRONTEND.md).
  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function toggle(node, cls, on) { if (node && node.classList.contains(cls) !== on) node.classList.toggle(cls, on); }
  function looksLikePrice(text) { return /[$£€¥]|\d/.test(text); }
  function amount(text) { var n = parseFloat(String(text).replace(/[^0-9.]/g, '')); return isFinite(n) ? n : Infinity; }

  // The element that scrolls this hero: the page, or the quick-view modal.
  function scroller(node) {
    for (var n = node.parentElement; n && n !== document.body; n = n.parentElement) {
      var oy = window.getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return null;
  }

  function bind(card) {
    if (card.dataset.kkContentsBound === '1') return;
    card.dataset.kkContentsBound = '1';
    var el = window.KKEl;
    var hero = card.closest('product-info') || document;
    var copy = card.dataset;
    var linked = /[?&]variant=/.test(window.location.search);
    var touched = {};
    var shown = {};   // line -> last value signature, for the change flash
    var first = true;

    function live(fs) {
      // Dawn keeps the replaced <variant-selects> for 500ms, hidden.
      var vs = fs.closest('variant-selects');
      return !(vs && vs.style.display === 'none');
    }
    function groups() { return toArray(hero.querySelectorAll('fieldset.var-block')).filter(live); }
    function labelOf(fs) {
      if (fs.hasAttribute('data-kk-sb-label')) return fs.getAttribute('data-kk-sb-label');
      var lg = fs.querySelector('legend');
      if (!lg) return '';
      var c = lg.cloneNode(true);
      toArray(c.querySelectorAll('.var-block__dot, .val, [data-selected-value]')).forEach(function (n) { n.remove(); });
      return textOf(c);
    }
    function keyOf(fs) { return norm(fs.getAttribute('data-kk-option-key') || labelOf(fs)); }
    function find(key) {
      var all = groups();
      for (var i = 0; i < all.length; i++) {
        if (norm(all[i].getAttribute('data-kk-option-key')) === key || norm(labelOf(all[i])) === key) return all[i];
      }
      return null;
    }
    function cards(fs) { return toArray(fs.querySelectorAll('.var-options .var-option')); }
    function state(fs) {
      var r = fs.querySelector('.var-options input[type="radio"]:checked');
      var c = r && r.closest('.var-option');
      var sub = c ? textOf(c.querySelector('.var-option__sub')) : '';
      return {
        input: r,
        card: c,
        value: c ? (textOf(c.querySelector('.var-option__title')) || r.value) : '',
        price: sub && looksLikePrice(sub) ? sub : '',
        none: !!(r && r.hasAttribute('data-kk-none')),
        optional: !!fs.querySelector('.var-options input[data-kk-none]'),
        blank: !r
      };
    }
    // The cheapest extra cost among the "yes" cards (for "Add …").
    function cheapest(fs) {
      var best = '';
      cards(fs).forEach(function (c) {
        var r = c.querySelector('input');
        if (!r || r.hasAttribute('data-kk-none') || r.disabled) return;
        var sub = textOf(c.querySelector('.var-option__sub'));
        if (sub && looksLikePrice(sub) && (!best || amount(sub) < amount(best))) best = sub;
      });
      return best;
    }

    // This line's own element (not one from a kit fold-out inside it).
    function own(line, sel) {
      var all = line.querySelectorAll(sel);
      for (var i = 0; i < all.length; i++) if (all[i].closest('[data-kk-line]') === line) return all[i];
      return null;
    }

    function paintPick(slot, c) {
      if (!slot) return;
      var src = c && c.querySelector('.var-option__thumb');
      var sig = src ? (src.querySelector('img') || src).outerHTML.length + ':' + textOf(c) : '';
      if (slot.getAttribute('data-sig') === sig) return;
      slot.setAttribute('data-sig', sig);
      while (slot.firstChild) slot.removeChild(slot.firstChild);
      if (src) slot.appendChild(src.cloneNode(true));
      slot.hidden = !src;
    }

    function paintLine(line) {
      var key = norm(line.getAttribute('data-kk-follow'));
      var fs = find(key);
      toggle(line, 'is-fixed', !fs);
      if (!fs) { toggle(line, 'is-declined', false); line.removeAttribute('data-kk-value'); return false; }
      var st = state(fs);
      var declined = st.none || (st.blank && st.optional);
      toggle(line, 'is-declined', declined);
      var extra = st.optional ? cheapest(fs) : '';
      setText(own(line, '[data-kk-add-price]'), extra ? '· ' + extra : '');
      var val = own(line, '[data-kk-line-val]');
      setText(val, st.blank ? (copy.unchosen || '') : st.value);
      toggle(val, 'is-empty', st.blank);
      setText(own(line, '[data-kk-line-add]'), st.blank ? '' : st.price);
      var pre = !st.blank && !linked && !touched[keyOf(fs)];
      setText(own(line, '[data-kk-line-pre]'), pre ? (copy.preselected || '') : '');
      setText(own(line, '[data-kk-go-t]'), st.blank ? (copy.choose || '') : (copy.change || ''));
      paintPick(own(line, '[data-kk-line-pick]'), st.blank || st.none ? null : st.card);
      if (st.blank || declined) line.removeAttribute('data-kk-value');
      else if (line.getAttribute('data-kk-value') !== st.value) line.setAttribute('data-kk-value', st.value);

      // Flash a line whose value changed (not on the first paint).
      var sig = st.blank ? '' : st.value;
      var id = line.getAttribute('data-kk-line-id');
      if (!id) { id = String(Math.random()).slice(2); line.setAttribute('data-kk-line-id', id); }
      if (!first && shown[id] !== sig && !declined) {
        line.classList.remove('is-flash');
        void line.offsetWidth; // restart the animation
        line.classList.add('is-flash');
        setTimeout(function () { line.classList.remove('is-flash'); }, 900);
      }
      shown[id] = sig;
      return true;
    }

    function qty() {
      var q = hero.querySelector('.quantity__input');
      var n = q ? parseInt(q.value, 10) : 1;
      return isFinite(n) && n > 0 ? n : 1;
    }

    function paintTotals() {
      var box = card.querySelector('[data-kk-contents-totals]');
      if (!box || !el) return;
      var sums = {};
      var order = [];
      // The bundle's own lines first, then what is inside them, so the
      // totals read in the card's order.
      var all = toArray(card.querySelectorAll('[data-kk-line][data-unit][data-qty]'));
      var inner = function (line) { return !!(line.parentElement && line.parentElement.closest('[data-mult]')); };
      all.filter(function (l) { return !inner(l); }).concat(all.filter(inner)).forEach(function (line) {
        // Skip a declined line, and anything inside one.
        for (var p = line; p && p !== card; p = p.parentElement) {
          if (p.classList.contains('is-declined')) return;
        }
        var n = parseFloat(line.getAttribute('data-qty'));
        if (!isFinite(n) || n <= 0) return;
        var mult = line.parentElement && line.parentElement.closest('[data-mult]');
        if (mult) n *= parseFloat(mult.getAttribute('data-mult')) || 1;
        var unit = String(line.getAttribute('data-unit'))
          .split('[value]').join(line.getAttribute('data-kk-value') || '')
          .replace(/\s+/g, ' ').trim();
        if (!unit) return;
        var k = norm(unit);
        if (!(k in sums)) { sums[k] = { n: 0, unit: unit }; order.push(k); }
        sums[k].n += n;
      });
      var row = box.querySelector('[data-kk-contents-totals-row]');
      var sig = order.map(function (k) { return sums[k].n + ' ' + sums[k].unit; }).join('|');
      if (row.getAttribute('data-sig') !== sig) {
        row.setAttribute('data-sig', sig);
        while (row.firstChild) row.removeChild(row.firstChild);
        order.forEach(function (k) {
          var cell = el('span', 'kk-contents__tot');
          cell.appendChild(el('b', null, String(Math.round(sums[k].n * 100) / 100)));
          cell.appendChild(el('span', null, sums[k].unit));
          row.appendChild(cell);
        });
      }
      setText(box.querySelector('[data-kk-contents-totals-lb]'), qty() > 1 ? (copy.totalsMulti || '') : (copy.totals || ''));
      if (box.hidden !== !order.length) box.hidden = !order.length;
    }

    function paint() {
      var follows = false;
      toArray(card.querySelectorAll('[data-kk-line][data-kk-follow]')).forEach(function (line) {
        if (paintLine(line)) follows = true;
      });
      var meta = card.querySelector('[data-kk-contents-meta]');
      if (meta && meta.hidden === follows) meta.hidden = !follows;
      paintTotals();
      first = false;
      if (!card.classList.contains('is-ready')) card.classList.add('is-ready');
    }

    // Change / Choose / Add: open the option and put focus on its cards.
    function openOption(key) {
      var fs = find(key);
      if (!fs) return;
      fs.dispatchEvent(new CustomEvent('kk:open-option', { bubbles: true }));
      var target = fs.querySelector('.kk-optrow__hd') || fs;
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var box = scroller(target);
      var top = target.getBoundingClientRect().top;
      if (box) {
        box.scrollTo({ top: box.scrollTop + top - box.getBoundingClientRect().top - 12, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        var offset = (parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0) + 16;
        window.scrollTo({ top: window.pageYOffset + top - offset, behavior: smooth ? 'smooth' : 'auto' });
      }
      var input = fs.querySelector('.var-options input[type="radio"]:checked') ||
        fs.querySelector('.var-options input[type="radio"]:not(:disabled)');
      if (input) input.focus({ preventScroll: true });
    }

    card.addEventListener('click', function (e) {
      var go = e.target.closest && e.target.closest('[data-kk-line-go]');
      if (go && card.contains(go)) {
        e.preventDefault();
        var line = go.closest('[data-kk-follow]');
        if (line) openOption(norm(line.getAttribute('data-kk-follow')));
        return;
      }
      var tg = e.target.closest && e.target.closest('[data-kk-nest-tg]');
      if (tg && card.contains(tg)) {
        var list = document.getElementById(tg.getAttribute('aria-controls'));
        var open = tg.getAttribute('aria-expanded') !== 'true';
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (list) list.hidden = !open;
        setText(tg.querySelector('[data-kk-nest-sh]'), open ? (copy.hide || '') : (copy.show || ''));
      }
    });

    // A pick anywhere in the buy box; the quantity changes the totals label.
    hero.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('quantity__input')) { paintTotals(); return; }
      var fs = t && t.closest && t.closest('fieldset.var-block');
      if (!fs) return;
      touched[keyOf(fs)] = true;
      paint();
    });
    // Dawn re-rendered <variant-selects> after a native pick.
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeName === 'VARIANT-SELECTS') { paint(); return; }
        }
      }
    }).observe(hero, { childList: true, subtree: true });

    paint();
  }

  function init() {
    if (!window.KKEl) return;
    toArray(document.querySelectorAll('[data-kk-contents]')).forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
